__turbopack_context__.v({
  "article-header": "ArticleHeader-module-scss-module__yQOpcG__article-header",
  "button-share": "ArticleHeader-module-scss-module__yQOpcG__button-share",
  "meta-container": "ArticleHeader-module-scss-module__yQOpcG__meta-container",
  "socials-container": "ArticleHeader-module-scss-module__yQOpcG__socials-container",
});
